/** List all tenants I have access to. */
export const tenantListMineSpec = {
    uri: '/t/list/mine',
    method: 'GET',
};
